import { render, staticRenderFns } from "./SendRecord.vue?vue&type=template&id=d0eec7d6&scoped=true"
import script from "./SendRecord.vue?vue&type=script&lang=js"
export * from "./SendRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0eec7d6",
  null
  
)

export default component.exports